import { V2Position, V2Vault } from '@/core/migrate';
import { MIGRATOR_ZAP } from '@/domain/migrate';
import MigratorZap from '@/domain/migrate/abis/MigratorZap';
import {
  Provider,
  Signer,
  Vault,
  getChainConstant,
  getContract,
} from 'nftx.js';

const migrateVToken = ({
  network,
  position,
  provider,
  signer,
  v2Vault,
  v3Vault,
}: {
  network: number;
  provider: Provider;
  signer: Signer;
  position: Pick<V2Position, 'migrateOptions'>;
  v2Vault: Pick<V2Vault, 'is1155' | 'id'>;
  v3Vault: Pick<Vault, 'vaultId'>;
}) => {
  const contract = getContract({
    provider,
    signer,
    address: getChainConstant(MIGRATOR_ZAP, network),
    abi: MigratorZap,
  });

  const is1155 = v2Vault.is1155;
  const vaultIdV3 = BigInt(v3Vault.vaultId);
  const vTokenV2 = v2Vault.id;
  const option = position.migrateOptions.find(
    (o) => o.vaultId === v3Vault.vaultId
  );
  if (!option) {
    throw new Error('Invalid vaultId');
  }
  const vTokenV2Balance = option.maxVToken;
  const minWethToReceive = 0n;

  return contract.write.v2VaultToXNFT({
    args: [vTokenV2, vTokenV2Balance, is1155, vaultIdV3, minWethToReceive],
  });
};

export default migrateVToken;
